import { render, staticRenderFns } from "./paySubscription.vue?vue&type=template&id=b28b1074&scoped=true"
import script from "./paySubscription.vue?vue&type=script&lang=js"
export * from "./paySubscription.vue?vue&type=script&lang=js"
import style0 from "./paySubscription.vue?vue&type=style&index=0&id=b28b1074&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b28b1074",
  null
  
)

export default component.exports